<picture>
  <img id="persona_{{personaId}}"
    class="c-image f-round"
    role="img"
    [attr.alt]="label"
    [attr.aria-label]="label"
    [src]="personsUrl"
    [appViImageFallback]="fallbackUrl" />
</picture>
